import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getImpersonatedUserToken } from '../../../api';

export const adminAuthenticationImpersonatedUserTokenGetSlice = createGetAsyncSlice({
	name: 'AdminAuthenticationImpersonatedUserToken',
	receive: true,
	request: true,
	requestHandler: getImpersonatedUserToken,
	retainDataOnRequest: false
});
